import { MetricType } from './metric-type';
import { WeeklyAllocationGoal } from './weekly-allocation-goal';

export class WeeklyAllocationMetric
{
    id: number;
    description: string;
    metricType: MetricType;
    sequenceNumber: number;

    goals: WeeklyAllocationGoal[];
}
